function extractExactPathFromURL(url) {
  if (
    // If a universal link / app link / web URL is used, we should use the path
    // from the URL, while stripping the origin.
    url.match(/^https?:\/\//)
  ) {
    var { origin, href } = new URL(url);
    return href.replace(origin, "");
  }
  return fromDeepLink(url);
}
function fromDeepLink(url) {
  var res;
  try {
    res = new URL(url);
  } catch (unused) {
    if (url.startsWith("/")) {
      return url;
    }
    return url.replace(/^[^:]+:\/\//, "");
  }
  var results = "";
  if (res.host) {
    results += res.host;
  }
  if (res.pathname) {
    results += res.pathname;
  }
  var qs = !res.search ? "" : (
    // @ts-ignore: `entries` is not on `URLSearchParams` in some typechecks.
    [
      ...res.searchParams.entries()
    ].map(function(param) {
      var [k, v] = param;
      return `${k}=${decodeURIComponent(v)}`;
    }).join("&")
  );
  if (qs) {
    results += "?" + qs;
  }
  return results;
}
function extractPathFromURL(_prefixes) {
  var url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var pathFromPrefix = extractPathFromPrefix(_prefixes, url);
  if (pathFromPrefix !== void 0) {
    return pathFromPrefix.replace(/^\//, "");
  }
  return extractExactPathFromURL(url).replace(/^\//, "");
}
function extractPathFromPrefix() {
  var prefixes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], url = arguments.length > 1 ? arguments[1] : void 0;
  var prefix = getMatchingPrefix(prefixes, url);
  if (!prefix) return void 0;
  return url.slice(prefix.length);
}
var PREFIX_BOUNDARY_CHARS = [
  "/",
  "?",
  "#"
];
function getMatchingPrefix(prefixes, url) {
  return prefixes.filter(function(prefix) {
    return matchesPrefix(prefix, url);
  }).sort(function(a, b) {
    return b.length - a.length;
  })[0];
}
function matchesPrefix(prefix, url) {
  if (!url.startsWith(prefix)) return false;
  if (url.length === prefix.length) return true;
  if (prefix.endsWith("/")) return true;
  return PREFIX_BOUNDARY_CHARS.includes(url[prefix.length]);
}
export {
  extractPathFromURL
};
//# sourceMappingURL=extractPathFromURL.js.map
